export default () => ({
  pickuppIcon: ({ size }) => ({
    width: size,
    height: size,
    fill: 'currentColor',
    display: 'inline-block',
    transition: '200ms fill ease',
  }),
})
